/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.28.0
 */

import { IAction, createAction } from '@/main/modules/app/createAction';

import { HISTORY_INQUIRY_INIT_ONBOARDING } from './constants';

/*
 * -------------------------------------------
 *           ONBOARDING
 * -------------------------------------------
 */

export type TInitHistoryInquiryOnboardingAction = IAction<typeof HISTORY_INQUIRY_INIT_ONBOARDING>;

export const initHistoryInquiryOnboarding = (): TInitHistoryInquiryOnboardingAction =>
    createAction(HISTORY_INQUIRY_INIT_ONBOARDING);
